/**
 * Created by Yu Zhang on 4/18/17.
 * Description:
 *
 * ------ maintenance history ------
 * ver1.1: modified by Alan Yang 5/5/17.
 *         added getFirstPageWithKeywordEffect, getNextPageWithKeywordEffect.
 * ver1.2: modified by Alan Yang 7/27/17.
 *         added RecentNotesEntityEffects, RecentNotesContactEffects.
 */
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ThreadService } from '../services/thread.service';
import { EntryService } from '../services/entry.service';
import {
    GET_FIRST_PAGE, GET_FIRST_PAGE_PARENTNOTEOWNATTACHMENT, GET_FIRST_PAGE_SUCCESS, GET_FIRST_PAGE_FAILURE,
    GET_NEXT_PAGE, GET_NEXT_PAGE_PARENTNOTEOWNATTACHMENT, GET_NEXT_PAGE_SUCCESS, GET_NEXT_PAGE_FAILURE,
    GET_RECENT_NOTES, GET_RECENT_NOTES_SUCCESS, GET_RECENT_NOTES_FAILURE, GET_THREAD_LIST_WITH_PAGGING,
    GET_THREAD_LIST_WITH_PAGGING_SUCCESS, GET_THREAD_LIST_WITH_PAGGING_FAILURE,
    GET_FIRST_PAGE_WITH_KEYWORD_ALL, GET_FIRST_PAGE_WITH_KEYWORD_ALL_SUCCESS, GET_FIRST_PAGE_WITH_KEYWORD_ALL_FAILURE,
    GET_NEXT_PAGE_WITH_KEYWORD_ALL, GET_NEXT_PAGE_WITH_KEYWORD_ALL_SUCCESS, GET_NEXT_PAGE_WITH_KEYWORD_ALL_FAILURE,
    GET_FIRST_PAGE_WITH_KEYWORD_CURRENT, GET_FIRST_PAGE_WITH_KEYWORD_CURRENT_SUCCESS, GET_FIRST_PAGE_WITH_KEYWORD_CURRENT_FAILURE,
    GET_NEXT_PAGE_WITH_KEYWORD_CURRENT, GET_NEXT_PAGE_WITH_KEYWORD_CURRENT_SUCCESS, GET_NEXT_PAGE_WITH_KEYWORD_CURRENT_FAILURE
} from './thread-list.actions';
import {
    GET_FIRST_PAGE_RECENT_NOTES_ENTITY, GET_NEXT_PAGE_RECENT_NOTES_ENTITY,
    GET_FIRST_PAGE_RECENT_NOTES_ENTITY_SUCCESS, GET_FIRST_PAGE_RECENT_NOTES_ENTITY_FAILURE,
    GET_NEXT_PAGE_RECENT_NOTES_ENTITY_SUCCESS, GET_NEXT_PAGE_RECENT_NOTES_ENTITY_FAILURE,
} from './thread-list.actions';
import { of as observableOf, Observable } from 'rxjs';
import { catchError, map, switchMap, mergeMap } from 'rxjs/operators';

@Injectable()
export class ThreadListEffects {
    constructor(private _actions$: Actions, private _threadService: ThreadService) { }

    getFirstPageEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_FIRST_PAGE),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._threadService.getThreadList(payload.page, payload.pageSize, payload.entityFocus,
            payload.keyword, payload.draft).pipe(
                map(response => {
                    const threadList = this._threadService.mapThreadList(response);
                    return ({
                        type: GET_FIRST_PAGE_SUCCESS,
                        payload: threadList
                    });
                }),
                catchError(err => {
                    return observableOf({ type: GET_FIRST_PAGE_FAILURE, payload: err.message });
                }))
        )));

    getFirstPageParentNoteOwnAttachmentEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_FIRST_PAGE_PARENTNOTEOWNATTACHMENT),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._threadService.getThreadListWithPagging(payload.page, payload.pageSize, payload.entityFocus,
            payload.keyword, payload.draft, payload.sortBy, payload.sortOrder).pipe(
                map(response => {
                    const threadList = this._threadService.mapThreadList_ForParentNoteOwnAttachment(response);
                    return ({
                        type: GET_FIRST_PAGE_SUCCESS,
                        payload: threadList
                    });
                }),
                catchError(err => {
                    return observableOf({ type: GET_FIRST_PAGE_FAILURE, payload: err.message });
                }))
        )));

    getNextPageEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_NEXT_PAGE),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._threadService.getThreadList(payload.page, payload.pageSize, payload.entityFocus, payload.keyword).pipe(
            map(response => {
                const threadList = this._threadService.mapThreadList(response);
                return ({
                    type: GET_NEXT_PAGE_SUCCESS,
                    payload: threadList
                });
            }),
            catchError(err => {
                return observableOf({ type: GET_NEXT_PAGE_FAILURE, payload: err.message });
            }))
        )));

    getNextPageParentNoteOwnAttachmentEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_NEXT_PAGE_PARENTNOTEOWNATTACHMENT),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._threadService.getThreadListWithPagging(payload.page, payload.pageSize, payload.entityFocus,
            payload.keyword, payload.draft, payload.sortBy, payload.sortOrder).pipe(
                map(response => {
                    const threadList = this._threadService.mapThreadList_ForParentNoteOwnAttachment(response);
                    return ({
                        type: GET_NEXT_PAGE_SUCCESS,
                        payload: threadList
                    });
                }),
                catchError(err => {
                    return observableOf({ type: GET_NEXT_PAGE_FAILURE, payload: err.message });
                }))
        )));

    getThreadListWithPaggingEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_THREAD_LIST_WITH_PAGGING),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._threadService.getThreadListWithPagging(payload.page, payload.pageSize, payload.entityFocus,
            payload.keyword, payload.draft, payload.sortBy, payload.sortOrder).pipe(
                map(response => {
                    const threadList = this._threadService.mapThreadList(response);
                    return ({
                        type: GET_THREAD_LIST_WITH_PAGGING_SUCCESS,
                        payload: threadList
                    });
                }),
                catchError(err => {
                    return observableOf({ type: GET_THREAD_LIST_WITH_PAGGING_FAILURE, payload: err.message });
                }))
        )));

}

@Injectable()
export class SearchAllThreadListEffects {
    constructor(private _actions$: Actions, private _threadService: ThreadService) { }

    getFirstPageWithKeywordAllEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_FIRST_PAGE_WITH_KEYWORD_ALL),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._threadService.getThreadList(payload.page, payload.pageSize, payload.entityFocus, payload.keyword).pipe(
            map(response => {
                const threadList = this._threadService.mapThreadList(response);
                return ({
                    type: GET_FIRST_PAGE_WITH_KEYWORD_ALL_SUCCESS,
                    payload: threadList
                });
            }),
            catchError(err => {
                return observableOf({ type: GET_FIRST_PAGE_WITH_KEYWORD_ALL_FAILURE, payload: err.message });
            }))
        )));

    getNextPageWithKeywordAllEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_NEXT_PAGE_WITH_KEYWORD_ALL),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._threadService.getThreadList(payload.page, payload.pageSize, payload.entityFocus, payload.keyword).pipe(
            map(response => {
                const threadList = this._threadService.mapThreadList(response);
                return ({
                    type: GET_NEXT_PAGE_WITH_KEYWORD_ALL_SUCCESS,
                    payload: threadList
                });
            }),
            catchError(err => {
                return observableOf({ type: GET_NEXT_PAGE_WITH_KEYWORD_ALL_FAILURE, payload: err.message });
            }))
        )));
}

@Injectable()
export class SearchCurrentThreadListEffects {
    constructor(private _actions$: Actions, private _threadService: ThreadService) { }

    getFirstPageWithKeywordCurrentEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_FIRST_PAGE_WITH_KEYWORD_CURRENT),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._threadService.getThreadList(payload.page, payload.pageSize, payload.entityFocus, payload.keyword).pipe(
            map(response => {
                const threadList = this._threadService.mapThreadList(response);
                return ({
                    type: GET_FIRST_PAGE_WITH_KEYWORD_CURRENT_SUCCESS,
                    payload: threadList
                });
            }),
            catchError(err => {
                return observableOf({ type: GET_FIRST_PAGE_WITH_KEYWORD_CURRENT_FAILURE, payload: err.message });
            }))
        )));

    getNextPageWithKeywordCurrentEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_NEXT_PAGE_WITH_KEYWORD_CURRENT),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._threadService.getThreadList(payload.page, payload.pageSize, payload.entityFocus, payload.keyword).pipe(
            map(response => {
                const threadList = this._threadService.mapThreadList(response);
                return ({
                    type: GET_NEXT_PAGE_WITH_KEYWORD_CURRENT_SUCCESS,
                    payload: threadList
                });
            }),
            catchError(err => {
                return observableOf({ type: GET_NEXT_PAGE_WITH_KEYWORD_CURRENT_FAILURE, payload: err.message });
            }))
        )));
}

@Injectable()
export class RecentNotesEffects {
    constructor(private _actions$: Actions, private _threadService: ThreadService, private _entryService: EntryService) { }

    getFirstPageRecentNotesEntityEffects$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_FIRST_PAGE_RECENT_NOTES_ENTITY),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._threadService.getThreadList(payload.page, payload.pageSize, payload.entityId,
            payload.keyword, false).pipe(
                map(response => {
                    const threadList = this._threadService.mapThreadList(response);
                    return ({
                        type: GET_FIRST_PAGE_RECENT_NOTES_ENTITY_SUCCESS,
                        payload: threadList
                    });
                }),
                catchError(err => {
                    return observableOf({ type: GET_FIRST_PAGE_RECENT_NOTES_ENTITY_FAILURE, payload: err.message });
                }))
        )));

    getNextPageRecentNotesEntityEffects$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_NEXT_PAGE_RECENT_NOTES_ENTITY),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._threadService.getThreadList(payload.page, payload.pageSize, payload.entityId,
            payload.keyword, false).pipe(
                map(response => {
                    const threadList = this._threadService.mapThreadList(response);
                    return ({
                        type: GET_NEXT_PAGE_RECENT_NOTES_ENTITY_SUCCESS,
                        payload: threadList
                    });
                }),
                catchError(err => {
                    return observableOf({ type: GET_NEXT_PAGE_RECENT_NOTES_ENTITY_FAILURE, payload: err.message });
                }))
        )));

    // for web2.0
    getRecentNotesEffects$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_RECENT_NOTES),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._entryService.getEntryList(payload.page, payload.pageSize, payload.entityId,
            payload.keyword, payload.entityId).pipe(
                map(response => {
                    const entryList = this._entryService.mapEntryList(response);
                    return ({
                        type: GET_RECENT_NOTES_SUCCESS,
                        payload: entryList
                    });
                }),
                catchError(err => {
                    return observableOf({ type: GET_RECENT_NOTES_FAILURE, payload: err.message });
                }))
        )));
}
